import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(amount: number): string {
  return `UGX ${amount.toLocaleString()}`;
}

/**
 * Deeply serializes data to ensure it is safe to pass to Client Components.
 * Converts Dates to strings, ObjectIds to strings, etc.
 */
export function serializeMongoData<T>(data: T): T {
  return JSON.parse(JSON.stringify(data));
}
/**
 * Safe ISO string conversion for timestamps or date strings.
 * Prevents "Invalid Date" RangeErrors.
 */
export function safeToISOString(value: any): string | null {
  if (!value) return null;
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) return null;
    return date.toISOString();
  } catch (e) {
    return null;
  }
}

/**
 * Safe date formatting for UI display.
 */
export function formatSafeDate(value: any, formatOptions?: Intl.DateTimeFormatOptions): string {
  if (!value) return '';
  try {
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleDateString(undefined, formatOptions);
  } catch (e) {
    return '';
  }
}
